import React, {Component} from 'react';
import Seller from './Seller';
import Buyer from './Buyer';
import PropTypes from 'prop-types';
import {getDateString, reportEvent} from '../helper';

class ProfileBanner extends Component {

    constructor(props) {
        super(props);

        this.state = {
            allowContact: props.allowContact
        };

        this.changeAllowContact = this.changeAllowContact.bind(this);
        this.clickContact = this.clickContact.bind(this);
    }

    changeAllowContact() {
        this.setState({
            allowContact: !this.state.allowContact
        });
    }


    clickContact() {
        reportEvent('contact_me.click', {
            'current_page_type': 'seller_page',
            'seller': {
                'id': this.props.userId
            }
        }, 'conversation');
    }

    render() {
        const {
            allowContact
        } = this.state;

        const {
            dateVal,
            isOnVacation,
            buyerMessage,
            isPageOwner,
            username,
            openPopup,
            isMobile
        } = this.props;

        const hideBannerClass = !isOnVacation ? ' hidden' : '',
            endDate = dateVal ? getDateString(dateVal) : dateVal;
  
        return (
            <div className={`banner profile-page cf${hideBannerClass}`}>
                <span className="suitcase"/>
                {
                    isPageOwner ?
                        (<Seller endDate={endDate}
                            buyerMessage={buyerMessage}
                            openPopup={openPopup}
                            isMobile={isMobile}/>)
                        : (<Buyer endDate={endDate}
                            buyerMessage={buyerMessage}
                            allowContact={allowContact}
                            username={username}
                            clickContact={this.clickContact}/>)
                }
            </div>
        );
    }
}

ProfileBanner.propTypes = {
    allowContact: PropTypes.bool,
    isPageOwner: PropTypes.bool,
    dateVal: PropTypes.number,
    buyerMessage: PropTypes.string,
    isOnVacation: PropTypes.bool
};

ProfileBanner.defaultProps = {
    allowContact: false,
    isPageOwner: false,
    isOnVacation: false,
    buyerMessage: ''
};


export default ProfileBanner;



// WEBPACK FOOTER //
// ./src/ProfileBanner/ProfileBanner.js